module.exports = __webpack_public_path__ + "8be62b5546eb6688a5d8c7e96f003b70.MP3";